/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import { Outlet } from "react-router-dom";
import loginStyles from "../../styles/Login.module.css"
import Footer from "../layout/footer"

export function UnprotectedPageContainerHeader(): JSX.Element {

    return (
        <>
            <div className='Basecontainer' style={{top:'0px', bottom:'0px',backgroundColor:"#FFFFFF"}}>
                <main  style={{height:"100%"}}>
                    <Outlet />
                    {/* <Footer /> */}
                </main>
            </div>
        </>
    )

} 